import { useQuery } from "vue-query"
import { useContext } from "@nuxtjs/composition-api"

import { ApiPaths, UserStatus } from "@/enums"
import { AreaOfInterest } from "@/types/models/AreaOfInterest"
import { CustomQueryHook } from "@/types/vue-query"

type ProfessionalStatus = {
  // eslint-disable-next-line camelcase
  professional_status?: UserStatus
}

type GetAreasOfInterestResponse = AreaOfInterest[]

export const getAreasOfInterest: CustomQueryHook<
  ProfessionalStatus,
  GetAreasOfInterestResponse
> = (params, options) => {
  const { $axios } = useContext()

  return useQuery(
    ["getAreasOfInterest", params],
    async () => {
      const { data } = await $axios.get<GetAreasOfInterestResponse>(
        ApiPaths.GET_AREAS_OF_INTEREST,
        { params },
      )

      return data
    },
    { ...options },
  )
}
